export default __webpack_public_path__ + "static/bunker_equipment_upgrade-41a6a65235adfeaaf60754a1eeb98ba6.png";